module.exports = __webpack_public_path__ + "img/Candler-t-21676-002-474x317.71bb89d3.jpg";